import React, { createContext, useState } from 'react';
import { retrieveLanguage }               from '../helpers/storage';
const { Provider, Consumer }              = createContext();

const ContextStore = ({ comp }) => {

  const defaultLanguage = retrieveLanguage() === null ? 'es-MX' : retrieveLanguage();

  const [language,          setLanguage]               = useState(defaultLanguage);

  const [errors,            setErrors]                 = useState({});
  const [isMobile,          setIsMobile]               = useState(false);
 
  const [modal, setModal]                              = useState({
    showModal:  false,
    closeModal: null,
    component:  null,
    customCss:  null,
    size:       'xl',
    backdrop:   null,
  });

  const contextValues = {
    modal,
    setModal, 
    language,
    setLanguage,
    errors,            
    setErrors,
    isMobile,          
    setIsMobile
  }

  return <Provider value={contextValues}>{comp}</Provider>
}

const WrapperConsumer = (Component) => {
  return (props) => (
    <Consumer>
      {(context) => <Component {...props} context={context} />}
    </Consumer>
  )
}

export default WrapperConsumer
export { ContextStore, Consumer }
